import {graphql} from 'babel-plugin-relay/macro';

export default graphql`
  query ProductQuery_Query($clearanceItemId: ID, $productId: ID!, $specialItemId: ID) {
    viewer {
      ...Product_viewer
    }
  }
`;
